import { DateService } from '@/services/date.service';
import { CarFilter, YearsFilter } from '@/types/filters/filters.types';
import { atom, DefaultValue, selector } from 'recoil';

const defaultYears: YearsFilter = {
  min: 0,
  max: 0,
};

export const searchYearTypesState = atom<CarFilter[]>({
  key: 'searchYearTypes',
  default: [],
});

export const searchYearTypeSearchOptionsSelector = selector({
  key: 'searchYearTypeSearchOptionsSelector',
  get: ({ get }) => {
    const searchYearTypes = get(searchYearTypesState);
    const searchYearTypeSearchOptions: CarFilter[] = searchYearTypes.filter(
      (option) => !option.isSelected
    );

    return { searchYearTypeSearchOptions };
  },
});

export const yearsFilterDefaultState = atom<YearsFilter>({
  key: 'yearsFilterDefaultState',
  default: {
    min: defaultYears.min,
    max: DateService.getFullYear(),
  },
});

export const yearsFilterState = atom<YearsFilter>({
  key: 'yearsFilter',
  default: defaultYears,
});

const selectedYearsFilterState = atom<YearsFilter>({
  key: 'selectedYearsFilterState',
  default: defaultYears,
});

export const selectedYearsFilterSelector = selector<YearsFilter>({
  key: 'selectedYearsFilterSelector',
  get({ get }) {
    return get(selectedYearsFilterState);
  },
  set({ get, set }, years) {
    if (years instanceof DefaultValue) {
      return;
    }

    const yearsFilterDefault = get(yearsFilterDefaultState);

    if (
      yearsFilterDefault.min === years.min &&
      yearsFilterDefault.max === years.max
    ) {
      return set(selectedYearsFilterState, { min: 0, max: 0 });
    }

    return set(selectedYearsFilterState, years);
  },
});

export const hasSelectedYearsFilterSelector = selector<boolean>({
  key: 'hasSelectedYearsFilter',
  get({ get }) {
    const { min, max } = get(selectedYearsFilterState);

    return Boolean(min) && Boolean(max);
  },
});

export const selectedYearsFilterLabelSelector = selector({
  key: 'selectedYearsFilterLabelSelector',
  get({ get }) {
    const hasSelectedYearsFilter = get(hasSelectedYearsFilterSelector);
    const { min, max } = get(selectedYearsFilterState);

    if (hasSelectedYearsFilter) {
      return `${min} - ${max}`;
    }

    return '';
  },
});
